import axios from "axios";

import { ExpandedUserMeResponse } from "types/users/me";

const getUserData = async (
  url: string,
  authorizationToken: string,
  locale: string,
) => {
  try {
    const { data } = await axios.get<ExpandedUserMeResponse>(
      `${url}/api/user/me/`,
      {
        headers: {
          Authorization: authorizationToken,
          "X-Locale": locale,
          "X-Api-Version": "2.0.0",
        },
      },
    );

    // The user data API returns the user object nested under a "user" key
    // The X-Api-Version should prevent that, but the 2.x gateway doesn't propegate headers
    // for GET requests. 3.x gateway does, so this is a temporary fix.
    if ("user" in data) {
      return data.user as ExpandedUserMeResponse;
    }

    return data;
  } catch (e) {
    console.error(`Failed to contact user data API, received ${e}`);
    console.error(
      `Authorization token: ${authorizationToken} (length: ${authorizationToken.length})`,
    );

    if (axios.isAxiosError(e)) {
      console.error(e.response?.data);
    }

    return null;
  }
};

const getServerSideUserData = async (
  authorizationToken: string,
  locale: string,
) => {
  const userData = await getUserData(
    `${process.env.GATEWAY_URL_SERVER}`,
    authorizationToken,
    locale,
  );

  return userData;
};

export { getServerSideUserData };
